<template>
  <v-container fluid
               class="pa-0">
    <v-row no-gutters
           v-show="!editMode">
      <AddressTemplate :Address="Customer.DefaultDeliveryAddress">
        <template v-slot:action-buttons>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-if="AllowChangeAddress"
                     v-bind="attrs"
                     v-on="on"
                     icon
                     @click="addressIdIsFromErp(Customer.DefaultDeliveryAddress.Id) ? null : edit(Customer.DefaultDeliveryAddress)">
                <v-icon :color="addressIdIsFromErp(Customer.DefaultDeliveryAddress.Id) ? 'disabled' : ''">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{addressIdIsFromErp(Customer.DefaultDeliveryAddress.Id) ?  $t("servicesystem.text.from_erp_locked in_ss", {ekey: ERPFriendlyName}) : $t("servicesystem.text.edit") }}</span>
          </v-tooltip>
        </template>
      </AddressTemplate>
    </v-row>
    <v-divider />
    <v-row no-gutters
           v-show="!editMode">
      <AddressList :CustomerId="Customer.Id"
                   showdetails
                   :closable="false"
                   ref="AddressList"
                   @Select="setAddress"
                   @New="edit({ CustomerId: Customer.Id, IsActive: true })"
                   @Edit="e => edit(e)">
      </AddressList>
    </v-row>
    <v-row no-gutters
           v-show="editMode">
      <AddressEdit :CustomerId="Customer.Id"
                   :Address="editObject"
                   :key="editObject ? editObject.Id : Date.now()"
                   @Created="setAddress"
                   @Changed="setAddress"
                   @Close="editMode = false">
      </AddressEdit>
    </v-row>
  </v-container>
</template>


<script>
import AddressTemplate from "@/components/Preview/Customer/AddressTemplate.vue";
import AddressList from "@/components/Preview/Customer/AddressList.vue";
import AddressEdit from "@/components/Preview/Customer/AddressEdit.vue";

export default {
  name: "CustomerAddresses",
  props: {
    Customer: Object,
  },
  components: {
    AddressList,
    AddressTemplate,
    AddressEdit,
  },

  data() {
    return {
      editMode: false,
      editObject: null,
    };
  },

  methods: {
    edit(address) {
      this.editObject = Object.assign({}, address);
      this.editMode = true;
    },
    setAddress(updated) {
      if (!this.Customer.DefaultDeliveryAddress || updated.Id == this.Customer.DefaultDeliveryAddress.Id) {
        this.Customer.DefaultDeliveryAddress = updated;
      }
      this.$refs.AddressList.updateItem(updated);
      this.editMode = false;
    },
  },

  computed: {
    AllowChangeAddress() {
      return !this.CustomerAddressReadonly && this.checkPermission("Actions", "editCustomerAddress");
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped>
</style>